import { render, staticRenderFns } from "./ViewItemInfo.vue?vue&type=template&id=305b5eb3&scoped=true&"
import script from "./ViewItemInfo.vue?vue&type=script&lang=js&"
export * from "./ViewItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./ViewItemInfo.vue?vue&type=style&index=0&id=305b5eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b5eb3",
  null
  
)

export default component.exports